import API from "../../../API/API";

const api = new API();

export const getTermsAndConditionsApi = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await api.get("legal/terms", { skipErrorHandling: true });
            resolve(result);
        } catch (error) {
            console.warn("getTermsAndConditionsApi error", error?.message);
            // Don't reject - return empty data instead to prevent page reload
            resolve({ data: { html: "" } });
        }
    });
};

export const getPrivacyPolicyApi = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await api.get("legal/privacy-policy", { skipErrorHandling: true });
            resolve(result);
        } catch (error) {
            console.warn("getPrivacyPolicyApi error", error?.message);
            // Don't reject - return empty data instead to prevent page reload
            resolve({ data: { html: "" } });
        }
    });
};

export const getCancellationRefundPolicyApi = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await api.get("legal/cancellation-refund-policy", { skipErrorHandling: true });
            resolve(result);
        } catch (error) {
            console.warn("getCancellationRefundPolicyApi error", error?.message);
            // Don't reject - return empty data instead to prevent page reload
            resolve({ data: { html: "" } });
        }
    });
};
